<script setup lang="ts">
    /**
     * Containers cannot be nested within one another.
     */
    declare interface ContainerProps {
        tag?: string;
        width?: 'default' | 'content' | 'full';
        noMargin?: boolean;
        /** @deprecated but still in use. Use 'width' prop instead */
        fullWidth?: boolean;
        /** @deprecated but still in use. Use 'width' prop instead */
        contentWidth?: boolean;
    }
    withDefaults(defineProps<ContainerProps>(), {
        tag: 'div',
        width: 'default',
    });
</script>
<template>
    <component
        :is="tag"
        :class="[
            'atm-container shrink-0',
            {
                'lg:mx-auto lg:min-w-[960px] lg:max-w-[960px] xl:min-w-[1200px] xl:max-w-[1200px]': !fullWidth || width !== 'full',
                'lg:!min-w-[792px] lg:!max-w-[792px]': (contentWidth && !fullWidth) || width === 'content',
                '!max-w-none': width === 'full',
                'mx-6 md:mx-8': !noMargin,
            },
        ]">
        <slot></slot>
    </component>
</template>
